app.controller("EmployeeSentDocumentsController", [
    "$scope", "$stateParams", "$rootScope", "ConfirmModal", "DocumentsService", "Socket", "$state", "$uibModal", "usSpinnerService", "toastr", "OrganizationalUnit",
    function ($scope, $stateParams, $rootScope, ConfirmModal, DocumentsService, Socket, $state, $uibModal, usSpinnerService, toastr, OrganizationalUnit) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.format = "dd-MM-yyyy";
        $scope.query = $stateParams.query || null;
        $scope.type = $stateParams.type || null;
        $scope.state = $stateParams.state || null;
        $scope.addressee = $stateParams.addressee || null;
        $scope.addresseeOrganizationalUnit = null;
        $scope.uniqueNumber = $stateParams.uniqueNumber || null;
        $scope.fromDate = $stateParams.fromDate ? new Date($stateParams.fromDate) : null;
        $scope.toDate = $stateParams.toDate ? new Date($stateParams.toDate) : null;
        $scope.documentTypes = {
            'INNER': [],
            'STUDENT_INNER': [],
            'OUTER': [],
            'DELETED': [],
            'OUTGOING': [],
            'OTHER': []
        };

        $scope.states = [
            { name: 'დაბლოკილი კანცელარიის მიერ', _id: 'rejected' },
            { name: 'წაუკითხავი', _id: 'unread' },
            { name: 'წაკითხული', _id: 'read' },
            { name: 'შესრულებული', _id: 'done' },
            { name: 'მიბრუნებული', _id: 'returned' },
            { name: 'გადამისამართებული', _id: 'resolved' }
        ];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.fromDateOptions = {
            maxDate: new Date()
        };

        $scope.toDateOptions = {
            minDate: new Date()
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        if ($stateParams.addressee) {
            DocumentsService.getEmployee($stateParams.addressee).then(function (emp) {
                $scope.addressee = emp;
            });
        }
        if ($stateParams.addresseeOrganizationalUnit) {
            OrganizationalUnit.getUnitById($stateParams.addresseeOrganizationalUnit).then(function (unit) {
                $scope.addresseeOrganizationalUnit = unit;
            });
        }

        var socket = new Socket("/documents");

        socket.on('chancelleryStatus', function () {
            $scope.loadPage();
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            data.forEach(function (type) {
                if (!type.isForStudent)
                    if (type.status) $scope.documentTypes[type.parentId].push(type);
                    else $scope.documentTypes.DELETED.push(type)
            });
            $scope.type = $stateParams.type || null;
        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                type: $scope.type,
                state: $scope.state,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                addressee: $scope.addressee ? $scope.addressee._id : null,
                addresseeOrganizationalUnit: $scope.addresseeOrganizationalUnit ? $scope.addresseeOrganizationalUnit._id : null,
            });
        };

        $scope.loadPage = function () {
            usSpinnerService.spin("root");
            DocumentsService.sentList({
                page: $stateParams.page,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                type: $scope.type,
                state: $scope.state,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $scope.addressee,
                addresseeOrganizationalUnit: $stateParams.addresseeOrganizationalUnit
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.totalItems = res.data.total;
                $scope.currentPage = $stateParams.page;

                usSpinnerService.stop("root");
            });
        };

        $scope.loadPage();

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.open = function (actionType, docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { actionType: actionType, documentId: docId, returnUrl: window.location.href })
        };

        $scope.select = function (docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.getEmployees = function (name) {
            if (name.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.generateStep = function (document) {
            if (document.author) {
                if (document.chancelleryStatus === 'returned') return 'chancellery-returned';
                if (document.chancelleryStatus == null) return 'review';
                if (document.chancelleryStatus == 'approved') {
                    if (document.status == 'done') return 'done';
                    if (document.status == 'returned') return 'returned';
                    else return 'approved'
                }
            } else {
                if (document.status == 'done') return 'done';
                if (document.status == 'returned') return 'returned';
                if (document.status == 'read') return 'read';
                if (document.status == 'unread') return 'unread';
            }
        };

        $scope.generateState = function (doc) {
            if (doc.deadline && doc.status !== 'done' && !(new Date(doc.deadline) > new Date())) {
                return true;
            }
            return false;
        };

        $scope.generateClass = function (document) {
            var step = $scope.generateStep(document);
            return 'doc-' + step;
        };

        $scope.generateTooltip = function (document) {
            var step = $scope.generateStep(document);

            var stepMap = {
                'unread': 'წაუკითხავი',
                'review': 'განხილვის პროცესში',
                'chancellery-returned': 'დაბლოკილია კანცელარიის მიერ',
                'approved': 'გაგზავნილი',
                'read': 'წაკითხული',
                'done': 'შესრულებული',
                'returned': 'მობრუნებული',
            };

            return stepMap[step];
        };


        $scope.showComment = function (comment, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment: comment,
                            action: 'view'
                        };
                    }
                }
            })
        };

        $scope.deleteDocument = function (documentId, e) {
            if (e) {
                e.stopPropagation();
            }
            ConfirmModal.show({
                title: "დოკუმენტის წაშლა",
                message: "ყურადღება! ნამდვილად გსურთ დოკუმენტის წაშლა?"
            }).result.then(function () {
                DocumentsService.deleteDocument(documentId).then(function (data) {
                    $rootScope.documentsCount();
                    toastr.success('', 'დოკუმენტი წარმატებით წაიშალა');
                    $scope.loadPage();
                });
            });
        }

        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({ query: query }).then(function (data) {
                return data;
            });
        };
    }
]);
